import _Button from "@material-ui/core/esm/Button";
import React, { useState } from 'react';
import cn from 'classnames';
import css from './fully-custom-box-selection.scss';
const FullyCustomBoxSelection = ({
  onBackHandler,
  onNext,
  showSuperSpeedConfPopup,
  note,
  isBoxTypeEdit,
  onChange
}) => {
  const [text, setText] = useState(note || '');
  return /*#__PURE__*/React.createElement("div", {
    className: css.container
  }, /*#__PURE__*/React.createElement("header", {
    className: css.header
  }, "Great choice!"), /*#__PURE__*/React.createElement("p", {
    className: css.text
  }, "Once you place your order, we\u2019ll figure out the right sized box for you and send over a design template so you can add your artwork. Be sure to check your email! If you have a question or want some help with design, let us know!"), /*#__PURE__*/React.createElement("textarea", {
    defaultValue: text,
    onChange: e => {
      const {
        value
      } = e.target;
      setText(value);
      onChange(value);
    },
    cols: 30,
    rows: 10,
    className: css.input,
    placeholder: "Let us know if you have any questions (optional)"
  }), /*#__PURE__*/React.createElement("div", {
    className: css.buttons
  }, /*#__PURE__*/React.createElement(_Button, {
    "data-button": "Back",
    className: cn(css.backButton, css.button),
    onClick: onBackHandler
  }, "Back"), /*#__PURE__*/React.createElement(_Button, {
    "data-button": "Continue",
    className: cn(css.continueButton, css.button),
    onClick: () => onNext(text, isBoxTypeEdit, showSuperSpeedConfPopup)
  }, isBoxTypeEdit ? 'Save' : 'Continue')));
};
export default FullyCustomBoxSelection;